// NOTE: Dependencies: jQuery, Defiant

(function($) {
    $.fn.contentTabs = function(options) {
        const $context = $(this);

        // check is dom element is defined
        if (!this.length) {
            return false;
        }

        // Default settings are set here.
        var settings = $.extend({
            $body: $('body'),
            $accordionWrapper: $('.content-tabbed'),
            accordionItem: '.content-tabbed__wrapper',
            activeClass: 'content-tabbed__wrapper--active',
            $collectionAccordion: $('.collection--accordion'),
            $loadMore: $('.content-tabbed__load-more'),
            loadMoreBtnClass: 'button--disabled',
            screenHeight: document.documentElement.clientHeight
        }, options);

        // These are all the methods available for the plugin.
        var methods = {};

        methods.setCurrentSettings = function() {
            var currentSettings = $context.data();

            if (!$.isEmptyObject(currentSettings)) {
                $context.data($.extend({}, settings, currentSettings));
            } else {
                $context.data(settings);
            }

            // Initialize item.
            $context.data('initialized', true);
            settings.$accordionItem = $(settings.accordionItem);
            settings.$accordionToggle = settings.$accordionItem.find('button.content-tabbed__item');
            settings.$tabLink = $context.find('.tabs__link'),
                settings.$tabContent = $context.find('.tabs__content');
        };

        // Bind events
        methods.events = function() {

            settings.$accordionToggle.on('click.contentTabs', function(event) {
                var $activeItem, $item, $itemParent;
                event.preventDefault();
                event.stopPropagation();
                $item = $(this).closest(settings.accordionItem);
                $itemParent = $item.parent();

                // Disabling the close all on desktop, but not on mobile
                if ((!$item.hasClass(settings.activeClass) && $(window).width() > 767) || ($(window).width() < 768)) {
                    $activeItem = $itemParent.find('.' + settings.activeClass);
                    $activeItem.height($activeItem.data('originalheight'));
                    $itemParent.find(settings.accordionItem).not($item).removeClass(settings.activeClass);
                    $item.toggleClass(settings.activeClass);
                    methods.setAccordionHeights($item);
                }
            });

            settings.$loadMore.on('click.contentTabs', function(event) {

                event.preventDefault();

                var $this = $(this),
                    $contentContainer = $this.closest('.content-tabbed__main-content'),
                    $dataContainer = $contentContainer.find('[data-ajax-url]'),
                    page = parseInt($dataContainer.attr('data-page')),
                    ajaxUrl = $dataContainer.attr('data-ajax-url').replace('{page}', page);

                if (!$this.hasClass(settings.loadMoreBtnClass)) {
                    $this.addClass(settings.loadMoreBtnClass);

                    $.ajax({
                        type: 'GET',
                        dataType: 'html',
                        url: ajaxUrl,
                        success: function(data) {

                            // On success 
                            var $html = $(data),
                                $firstItem = $html.filter('.grid__col').first(),
                                pageCountTotal = $firstItem.data('pagecount-total'),
                                newPage = page + 1;

                            // Remove disabled class if not last page
                            if (page != pageCountTotal) {
                                $this.removeClass(settings.loadMoreBtnClass);
                            }

                            // Append data
                            $dataContainer.append(data);

                            // Resetting ajax page so manipulation can occur everytime.
                            $dataContainer.attr('data-page', newPage);

                            // Reinit tabs
                            methods.mobileCheck();
                            methods.accordionInit();
                        }
                    });
                }
            });

            $(window).on('resize', function() {
                var resizeId;
                if (document.documentElement.clientHeight !== settings.screenHeight) 
				{
                    settings.screenHeight = document.documentElement.clientHeight;
                    clearTimeout(resizeId);

                    resizeId = setTimeout((function() {

                        if (settings.$collectionAccordion.length) {
                            settings.$collectionAccordion.css('display', 'block');
                        }

                        $.each(settings.$accordionWrapper, function() {
                            var $accordion = $(this),
                                $accordionItem = $accordion.find(settings.accordionItem);

                            $accordionItem.removeClass(settings.activeClass).css('height', 'auto');
                            $accordion.find(settings.accordionItem + ':not(".content-tabbed__wrapper--title")').first().addClass(settings.activeClass);
                        });

                        methods.mobileCheck();
                        methods.accordionInit();
                    }), 250);
                }
            });
        };

        methods.setAccordionHeights = function($item) {
            if ($item.hasClass(settings.activeClass)) {
                $item.css('height', $item.attr('data-totalheight'));
            } else {
                $item.css('height', $item.attr('data-originalheight'));
            }
        };

        methods.mobileCheck = function() {
            if (settings.$accordionItem.parent().css('display') === 'block') {
                settings.$accordionItem.removeClass(settings.activeClass);
            }
        };

        methods.accordionInit = function() {

            $.each(settings.$accordionWrapper, function() {
                var $accordion = $(this),
                    $accordionItem = $accordion.find(settings.accordionItem),
                    accordionItemLength = $accordionItem.length,
                    descriptionWidth = (100 * accordionItemLength) + '%';

                $.each($accordionItem, function(index) {
                    var $item = $(this),
                        $content = $item.find('.content-tabbed__item'),
                        $description = $item.find('.content-tabbed__main-content'),
                        contentHeight = Math.floor($content.outerHeight());

                    if ($(window).width() > 767) {
                        $description.css('width', descriptionWidth);

                        // Set top and width
                        $description.css('top', contentHeight);
                    } else {
                        $description.css('width', '100%');
                        $description.css('top', 0);
                    }

                    // Set heights

                    var descriptionHeight = Math.floor($description.outerHeight()),
                        totalHeight = contentHeight + descriptionHeight;

                    $item.height(contentHeight).attr({
                        'data-originalheight': contentHeight,
                        'data-totalheight': totalHeight
                    });

                    methods.setAccordionHeights($item);

                    if (settings.$collectionAccordion.length && (index == $accordionItem.length - 1)) {

                        $.each(settings.$collectionAccordion, function() {
                            var id = $(this).attr('id');

                            if (!$('*[data-collection-id="#' + id + '"]').hasClass('collection-toggle--active')) {
                                settings.$collectionAccordion.css('display', 'none');
                            }
                        });

                    }

                });
            });
        };

        methods.initContext = function() {
            methods.setCurrentSettings();
            methods.mobileCheck();
            methods.accordionInit();
        };

        // Filter each function.
        methods.filterEach = function() {
            return !$(this).data('initialized');
        };

        // NOTE: Method you'd like initialized on a per context basis.
        $context.imagesLoaded(function() {
            methods.initContext($(this));
            methods.events(this);
        });
    };

    if ($('.content-tabbed').length) {
        $('.content-tabbed').contentTabs();
    }

}(jQuery));